module.exports = __webpack_public_path__ + "img/dental7_7-8-2021.f9b187b5.jpg";